@import '@hevoio/hevo-ui-toolkit/styles/variables';

.heading {
  color: $default-secondary;
}

.content {
  color: $text-default;
  font-weight: $font-weight-medium;
}
